import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import submit from "submit-form";

export const ExploreSelector = ({ widgetTypesList, defaultWidget }) => {
  const { t } = useTranslation("coaching-portal");
  const [listOpened, setListOpened] = useState(false);
  const [selectedWidget, setSelectedWidget] = useState(defaultWidget || null);

  useEffect(() => {
    selectedWidget &&
      submit(`/actions/refresh/`, {
        method: "GET",
        body: { section: "learn", learn: selectedWidget.learnmoreLink },
      });

    return () => {};
  }, [selectedWidget]);

  return (
    <div className="only-show-mobile">
      <details role="list" open>
        <summary
          onClick={(e) => {
            e.preventDefault();
            setListOpened(!listOpened);
          }}
          haspopup="listbox"
        >
          {selectedWidget ? (
            <p>{t(selectedWidget.titleKey)}</p>
          ) : (
            <p>{t("widgets.explore")}</p>
          )}
          <SvgIcon
            src={
              listOpened ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"
            }
          />
        </summary>
        <ul className={listOpened ? "opened" : ""}>
          {widgetTypesList.map((widget, idx) => {
            return (
              <li
                key={`w-${idx}-${widget.learnmoreLink}`}
                onClick={(e) => {
                  setListOpened(!listOpened);
                  setSelectedWidget(widget);
                }}
              >
                <span>{t(widget.titleKey)}</span>
              </li>
            );
          })}
        </ul>
      </details>
    </div>
  );
};
